import { getWhiteListGeneralUrlTargets, getWhiteListTargets } from "services/baseUrl";
import { ConditionName, IEnvironment } from "../interfaces";
import { conditions } from "./conditions/conditions";

export const whiteListTargets = getWhiteListTargets() ? getWhiteListTargets().split(',') : [];

export const whiteListGeneralUrlTargets = getWhiteListGeneralUrlTargets() ? getWhiteListGeneralUrlTargets().split(',') : [];

export const ENVIRONMENT: IEnvironment = {
    reduxDevTool: true
}

export const sportBackBtnArea = 16;  /// default padding equal 20

export const activeElementsTime = 3000;

export const showLoaderTime = 3000;

export const livePlayRetryDuration = 3000;

export const RetryCountGeneralDataFetch = 3;

export const RetryTimeDelayGeneralDataFetch = 5;

export const justAudio = 64;

export const footerPadding = () => {
    if (conditions(ConditionName.footerPaddingZero)) return 0;
    else return 64
}

export const featureToggle = "ft";

export const sidebarWidth = 357;